import Professional from "../../models/Professional";
import FormBase from "../FormBase";
import FormFieldBase from "../FormFieldBase";
import ValidationBase, { ValidationType } from "../ValidationBase";
import TermsDeclarations from '../../models/TermsDeclarations'
import TermsDeclarationsService from "../../services/TermsDeclarationsService";


export default class TermsDeclarationsForm implements FormBase {

    AbsenceConflictDeclaration: FormFieldBase;
    SupplierDeclaration: FormFieldBase;
    RefusalPresentVaccineTerm: FormFieldBase;
    ImmunityDeclaration: FormFieldBase;
    ClinicalStaffDeclaration: FormFieldBase;

    constructor(AbsenceConflictDeclaration: boolean, SupplierDeclaration: boolean, RefusalPresentVaccineTerm: boolean, ImmunityDeclaration: boolean, ClinicalStaffDeclaration: boolean) {
        this.AbsenceConflictDeclaration = new FormFieldBase(new TermsDeclarations(0, AbsenceConflictDeclaration), [], ((value: any) => { return this.ValidateFieldCustom(value) }));
        this.SupplierDeclaration = new FormFieldBase(new TermsDeclarations(0, SupplierDeclaration), [], ((value: any) => { return this.ValidateFieldCustom(value) }));
        this.RefusalPresentVaccineTerm = new FormFieldBase(new TermsDeclarations(0, RefusalPresentVaccineTerm), [], ((value: any) => { return this.ValidateFieldCustom(value) }));
        this.ImmunityDeclaration = new FormFieldBase(new TermsDeclarations(0, ImmunityDeclaration), [], ((value: any) => { return this.ValidateFieldCustom(value) }));
        this.ClinicalStaffDeclaration = new FormFieldBase(new TermsDeclarations(0, ClinicalStaffDeclaration), [new ValidationBase("", ValidationType.CUSTOM)], ((value: any) => { return this.ValidateFieldCustom(value) }));
    }

    ValidateFieldCustom(value: any): string {
        if (!value || !value.Checked) {
            return "É preciso aceitar os termos e declarações."
        } else {
            return "";
        }
    }

    static NewInstance(): TermsDeclarationsForm {
        return new TermsDeclarationsForm(false, false, false, false, false);
    }

    CallInsertOrUpdateApi(professional: Professional, customAttributes?: any): Promise<any> {
        const dataJson = this.getJsonObjet();
        return TermsDeclarationsService.postInsertOrUpdateTermsDeclarations(dataJson, professional.Id);
    }

    ValidateToGoNextStep(): string {

        let propNames = ["AbsenceConflictDeclaration", "SupplierDeclaration", "RefusalPresentVaccineTerm", "ImmunityDeclaration", "ClinicalStaffDeclaration"];

        let formIsValid = true;

        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];
            const error = this.GetFieldByName(element).ValidateField();

            if (error !== null && error !== "") {
                formIsValid = false;
            }
        }

        if (!formIsValid) {
            return "Por favor, aceite os termos e declarações."
        } else {
            return "";
        }

    }

    GetFieldByName(name: string): FormFieldBase {

        switch (name) {

            case "AbsenceConflictDeclaration":
                return this.AbsenceConflictDeclaration
            case "RefusalPresentVaccineTerm":
                return this.RefusalPresentVaccineTerm
            case "SupplierDeclaration":
                return this.SupplierDeclaration
            case "ImmunityDeclaration":
                return this.ImmunityDeclaration
            case "ClinicalStaffDeclaration":
                return this.ClinicalStaffDeclaration
            default:
                return new FormFieldBase("", []);
        }
    }

    getJsonObjet(professionalId: number = 0) {

        let viewModelList: any[] = [];

        viewModelList.push({ "textId": this.AbsenceConflictDeclaration.Value.TextId, "checked": this.AbsenceConflictDeclaration.Value.Checked })
        viewModelList.push({ "textId": this.RefusalPresentVaccineTerm.Value.TextId, "checked": this.RefusalPresentVaccineTerm.Value.Checked })
        viewModelList.push({ "textId": this.SupplierDeclaration.Value.TextId, "checked": this.SupplierDeclaration.Value.Checked })
        viewModelList.push({ "textId": this.ImmunityDeclaration.Value.TextId, "checked": this.ImmunityDeclaration.Value.Checked })
        viewModelList.push({ "textId": this.ClinicalStaffDeclaration.Value.TextId, "checked": this.ClinicalStaffDeclaration.Value.Checked })

        return viewModelList;
    }
}